import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  handleImageFailure,
  handleImageLoading,
  handleImageSuccess,
} from '@/redux/slices/imageDisplaySlice';

interface Loading {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
}

const useImageDisplayTracking = (year: string, loading: Loading) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (loading.isLoading) {
      dispatch(handleImageLoading(year));
    }
  }, [year, dispatch, loading.isLoading]);

  useEffect(() => {
    if (loading.isSuccess) {
      dispatch(handleImageSuccess(year));
    }
  }, [year, dispatch, loading.isSuccess]);

  useEffect(() => {
    if (loading.isError) {
      dispatch(handleImageFailure(year));
    }
  }, [year, dispatch, loading.isError]);
};

export default useImageDisplayTracking;
